var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"padding":"0"}},[_c('el-input-number',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"controls":false,"size":"small","min":1},on:{"blur":_vm.handleBlur}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }